import PricingPreview from '../components/PricingPreview';
import { useTranslation } from 'react-i18next';

export default function Pricing() {
  const { t } = useTranslation();
  return (
    <>
      <section className="border-b border-border bg-surface">
        <div className="mx-auto max-w-4xl px-4 py-16 text-center">
          <h1 className="text-4xl font-bold sm:text-5xl">{t('pricing.title')}</h1>
          <p className="mt-4 text-text-muted">{t('pricing.subtitle')}</p>
        </div>
      </section>
      <PricingPreview />
    </>
  );
}
